import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import oilBottle from './assets/oil-bottle.png';
import './styles.scss';

const ScheduleButton = () => {
  const history = useHistory();

  const [onScrolling, setOnScrolling] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 400) {
      setOnScrolling(true);
    } else {
      setOnScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`text-center text-md-right schedule-button-box wrapper fade-in ${onScrolling ? 'scrolling' : ''}`}>
      <button className="btn-yellow rounded-shell text-uppercase red-text schedule-button-size desktop-display shell-bold align-items-center" onClick={ () => { history.push('/app'); } }>
          <img src={oilBottle} className="schedule-button-icon" alt='Bidón de aceite'/>
          Agenda tu cambio de aceite aquí
      </button>
      <button className="btn-yellow rounded-shell text-uppercase red-text schedule-button-size mobile-display shell-bold align-items-center" onClick={ () => { history.push('/app'); } }>
          <img src={oilBottle} className="schedule-button-icon" alt='Bidón de aceite'/> Agenda aquí
      </button>
    </div>
  );
};

export default ScheduleButton;
